var React = require('react');

function DownArrowSmall (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"V4","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"TB_Website_Desktop","transform":"translate(-699.000000, -822.000000)","stroke":"#222A35","strokeWidth":"4"},React.createElement("g",{"id":"Home-screen-1","transform":"translate(52.000000, 382.000000)"},React.createElement("g",{"id":"Animation"},React.createElement("polyline",{"id":"Path-2","transform":"translate(668.000000, 444.000000) rotate(-135.000000) translate(-668.000000, -444.000000)","points":"656.538849 459 653 429 683 432.538849"}))))));
}

DownArrowSmall.defaultProps = {"width":"42px","height":"29px","viewBox":"0 0 42 29","version":"1.1"};

module.exports = DownArrowSmall;

DownArrowSmall.default = DownArrowSmall;
